module.exports = __webpack_public_path__ + "static/media/hw_ha_26.27b82ade.flv";